var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 46,
    viewBox: "0 0 182 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7568 32.5581C34.6176 40.207 27.6814 45.9752 18.8645 45.9752C7.32533 45.9755 0 37.0961 0 27.3088C0 16.8734 7.97381 8.64233 18.5405 8.64233C26.9682 8.64233 34.5532 13.8273 36.7568 22.318H29.8203C28.0054 17.5868 23.597 14.9298 18.8001 14.9298C15.2344 14.8647 12.6412 16.0309 10.1778 18.3646C8.10329 20.4387 6.74195 23.7441 6.74195 27.3091C6.74195 34.5682 12.0578 39.6884 18.8001 39.6884C24.6994 39.6233 28.3942 36.0594 29.8203 32.5584H36.7568V32.5581Z",
    fill: "#FF7B72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2347 44.8062H72.7612V38.8934C70.3961 43.4371 65.5411 45.8018 60.1879 45.8018C49.2948 45.8018 42.8213 37.3378 42.8213 27.8787C42.8213 17.5481 50.3528 9.95557 60.1879 9.95557C66.9102 9.95557 71.2053 13.6901 72.7612 16.9255V10.9515H79.2347V44.8062ZM49.2948 28.0039C49.3567 33.0443 52.9052 39.7651 61.1214 39.7651C66.2878 39.7651 69.9601 36.902 71.6409 33.0443C72.3879 31.4887 72.7616 29.7456 72.8239 28.0039C72.8858 26.2608 72.5748 24.5184 71.8278 22.9618C70.2092 19.0415 66.4123 15.9926 60.9965 15.9926C53.9009 15.9926 49.2944 21.5937 49.2944 27.9413V28.0039H49.2948Z",
    fill: "#FF7B72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8945 0H94.457V24.9947L107.413 11.9195H115.077L100.357 26.4539L115.503 45.0025H108.143L94.457 27.9739V45.0021H87.8945V0Z",
    fill: "#FF7B72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.477 11.922H171.438V16.7872C173.324 12.895 176.791 10.3066 181.292 10.2454V16.5705H180.866C175.08 16.9054 171.803 20.5569 171.803 27.1254V45.0045H165.477V11.922H165.477Z",
    fill: "#FF7B72"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.33 23.2272H122.366V17.5758L132.007 14.6338L156.33 17.5758V23.2272Z",
    fill: "#FF7B72"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.33 28.1094H122.366V33.6676H156.33V28.1094Z",
    fill: "#FF7B72"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.33 38.55H122.366V44.1083H156.33V38.55Z",
    fill: "#FF7B72"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.406 11.6497C141.423 11.6497 143.059 10.0143 143.059 7.99707C143.059 5.9798 141.423 4.34448 139.406 4.34448C137.388 4.34448 135.752 5.9798 135.752 7.99707C135.752 10.0143 137.388 11.6497 139.406 11.6497Z",
    fill: "#FF7B72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceTitle);
export default __webpack_public_path__ + "static/media/ServiceTitle.d571ca1528c31e6f016273c06c5c8941.svg";
export { ForwardRef as ReactComponent };